var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',{staticClass:"animated fadeIn"},[_c('basic-heading',{staticClass:"print-hidden mb-3",attrs:{"title":"Receiving Labels"}}),_c('sample-receiving-labels',{attrs:{"samples":_vm.samples,"submission":_vm.submission}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }